import { Container, Typography, Button, Stack } from "@mui/material";
import { Link as RouterLink } from "react-router";

export default function AccessDeniedPage() {
  return (
    <Container sx={{ mt: 10, mb: 10 }}>
      <Stack spacing={2}>
        <Typography variant="h4" fontWeight={700}>
          Access denied
        </Typography>
        <Typography variant="body1" color="text.secondary">
          You do not have permission to view this page.
        </Typography>
        <Stack direction="row" spacing={2}>
          <Button component={RouterLink} to="/companies" variant="contained">
            Back to Companies
          </Button>
          <Button component={RouterLink} to="/" variant="text">
            Go Home
          </Button>
        </Stack>
      </Stack>
    </Container>
  );
}
